
import { tableColumnsListAgents } from "./AgentsTable";
import AgentsTableOperationTableVue from "./AgentsTableOperationTable.vue";
import NoResultsFound from "@/components/NotFound/NoResultsFound.vue";

import {
  agentApplicationsMapActions,
  agentApplicationsMapGetters
} from "@/store/modules/agentApplications";
import VueWithMixins from "@/helpers/mixins";
import AgentApplicationMixin from "./AgentApplicationMixin";
import { getPrintMethod } from "@/helpers/printMethodHelper";
import PrintMethodModal from "@/components/Dialog/PrintMethodModal.vue";
import { clearSelectionsNotInData } from "@/helpers";

export default VueWithMixins(AgentApplicationMixin).extend({
  name: "agents",
  components: {
    Exporter: () => import("@/components/Exporter/Exporter.vue"),
    NoResultsFound,
    PrintMethodModal
  },
  data() {
    return {
      tableColumns: tableColumnsListAgents,
      successMessage: "",
      filters: [
        {
          field: "status",
          title: "Status",
          options: [
            { label: "Spam", value: "spam" },
            { value: "rejected", label: "Rejected" },
            { value: "approved", label: "Approved" },
            { value: "pendingApproval", label: "Pending Approval" }
          ]
        },
        {
          field: "createdOn",
          title: "Created On",
          options: [],
          isDate: true
        }
      ],
      tableRowActions: [
        { label: "Print", value: "print", faIcon: "print" },
        { label: "View", value: "view", faIcon: "eye" },
        {
          label: "Delete",
          value: "delete",
          faIcon: "trash-alt",
          class: "bg-red-400 text-white hover:text-white hover:bg-red-500"
        }
      ],
      agentId: "",
      selectedDocuments: [] as any[],
      reserveSelection: true,
      bulkMenuActions: [{ title: "Delete Selected", disabled: false }],
      activeModal: ""
    };
  },
  methods: {
    async viewCallback(dataReceived: any): Promise<any> {
      const { _id } = dataReceived;
      this.$router.push(`/admin/agent_application/${_id}`);
    },
    tableActionHandler(action: string) {
      switch (action) {
        case "Export Agent Applications":
          this.$modal.show("exportAgentApplicationsModal");
          break;
        default:
          break;
      }
    },
    ...agentApplicationsMapActions([
      "getAgentApplications",
      "deleteAgentApplications",
      "deleteBulkAgentApplications",
      "printAgentApplication"
    ]),
    async fetchPageData(queryObject: any) {
      try {
        this.loadingText = "Fetching agent applications. Please wait...";
        this.loading = true;
        this.$emit("scrollTop");
        await this.getAgentApplications({ query: { ...queryObject } });
        this.selectedDocuments = clearSelectionsNotInData(
          this.agentApplications,
          this.selectedDocuments
        );
      } catch (error) {
        this.$bugSnagClient.notify(error);
      } finally {
        this.loading = false;
        this.loadingText = "";
        this.reserveSelection = true;
      }
    },
    // list view action
    async handleResponseAction(payload: any) {
      const { data } = payload;
      switch (payload.name) {
        case "print": {
          const printMethod = await getPrintMethod(this);
          await this.printCallback(data._id, printMethod);
          break;
        }
        case "delete":
          await this.deleteCallback(data._id);
          break;
        case "view":
          this.$router
            .push(`/admin/agent_application/${data._id}`)
            .catch(() => {});
          break;
        default:
          this.errorMessage = "Operation specified is not supported";
      }
    },
    async deleteCallback(agentID: string) {
      try {
        this.agentId = agentID;
        this.$modal.show("agentApplicationsModal");
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
        // delete disabled
      }
    },
    async deleteOneAgentApplication() {
      try {
        this.loadingText = "Deleting agent application. Please wait...";
        await this.deleteAgentApplications(this.agentId);
        this.$modal.hide("agentApplicationsModal");
        this.$appNotifySuccess("Agent Application Deleted Successfully.");
      } catch (e) {
        this.errorMessage = e.message;
        this.$bugSnagClient.notify(e);
      } finally {
        this.loadingText = "";
      }
    },
    async bulkActionHandler(action: string) {
      switch (action) {
        case "Delete Selected": {
          this.activeModal = "bulkAgentApplicationDeleteModal";
          this.$nextTick(() => {
            this.$modal.show(this.activeModal);
          });
          break;
        }
        case "Print Selected": {
          try {
            const printMethod = await getPrintMethod(this);
            const _ids = this.selectedDocuments.map((doc: any) => doc._id);
            await this.bulkPrintCallback(_ids, printMethod);
          } catch (error) {
            this.errorMessage = (error as any).message;
          }
          break;
        }
        default:
          break;
      }
    },
    async doDeleteBulkAgentApplications() {
      try {
        this.loadingText =
          "Deleting selected agent applications. Please wait...";
        const agentApplicationIds = this.selectedDocuments.map(
          (document: any) => document._id
        );
        await this.deleteBulkAgentApplications(agentApplicationIds);
        this.$appNotifySuccess(
          "Selected agent applications deleted successfully."
        );
        this.fetchPageData(
          this.$store.state.list_view_module["filterQuery"] || {}
        );
      } catch (e) {
        this.errorMessage = e.message;
        this.$bugSnagClient.notify(e);
      } finally {
        this.$modal.hide(this.activeModal);
        this.loadingText = "";
      }
    },
    getAgentOperationsTable() {
      return AgentsTableOperationTableVue;
    }
  },
  computed: {
    ...agentApplicationsMapGetters([
      "agentApplications",
      "editingAgentApplication",
      "getTotalRecords",
      "getAgentApplicationLinks"
    ]),
    tableActions(): string[] {
      if (this.$isCurrentUserAdmin) {
        return ["Export Agent Applications"];
      }
      return [];
    },
    bulkMenuActionsData(): { title: string; disabled: boolean }[] {
      return [{ title: "Print Selected", disabled: false }];
    }
  }
});
